import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createMainDealer } from "@/api/mainDealers";
import { MainDealersQueryKeys, useUserManager } from "@/tanstackQuery/queries";

export const useCreateMainDealer = () => {
  const queryClient = useQueryClient();
  const userManager = useUserManager();
  return useMutation({
    mutationFn: createMainDealer,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [MainDealersQueryKeys.All],
      });
      // The opening balance is paid by the creator when it holds a pool
      // (agent, operator, credit seller), so its own balance moved too.
      // Refetched unconditionally rather than re-deriving the server's rule.
      userManager.invalidate();
    },
  });
};
